import { FC } from 'react';

const ItemPlayercard: FC<{ file: string }> = props => (
  <img className="shadow-lg w-full h-auto" src={`${process.env.PUBLIC_URL}/playercards/${props.file}.png`} alt={'Playercard'} />
);
export default ItemPlayercard;
